export type InputFormatter = (value: string) => string

/** Strips non-digits, inserts dashes: 123456789 → 123-45-6789 */
export function formatSSN(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 9)
  if (digits.length <= 3) return digits
  if (digits.length <= 5) return `${digits.slice(0, 3)}-${digits.slice(3)}`
  return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`
}

/** Strips non-digits, inserts dash: 123456789 → 12-3456789 */
export function formatFEIN(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 9)
  if (digits.length <= 2) return digits
  return `${digits.slice(0, 2)}-${digits.slice(2)}`
}

/** Strips non-digits, formats as (###) ###-####  */
export function formatPhone(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 10)
  if (digits.length <= 3) return digits
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
}

/** Strips non-digits (except decimal), adds thousand separators: 1234567.89 → 1,234,567.89 */
export function formatMoney(value: string): string {
  const cleaned = value.replace(/[^\d.]/g, '')
  const dotIndex = cleaned.indexOf('.')
  const intRaw = dotIndex === -1 ? cleaned : cleaned.slice(0, dotIndex)
  const intPart = intRaw.slice(0, 7)
  if (intPart === '') return ''
  const formatted = Number(intPart).toLocaleString('en-US')
  if (dotIndex === -1) return formatted
  const decPart = cleaned
    .slice(dotIndex + 1)
    .replace(/\./g, '')
    .slice(0, 2)
  return `${formatted}.${decPart}`
}

/** Strips non-digits, inserts dash for ZIP+4: 123456789 → 12345-6789 */
export function formatZip(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 9)
  if (digits.length <= 5) return digits
  return `${digits.slice(0, 5)}-${digits.slice(5)}`
}
